module.exports = __webpack_public_path__ + "static/media/user-minus.e90d2151.svg";